
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ut8b_1vvgk_93",
  "label": "awsui_label_1ut8b_1vvgk_97",
  "stud": "awsui_stud_1ut8b_1vvgk_111"
};
  